import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { FaArrowUp } from "react-icons/fa6";
// import CustomMap from "./CustomMap";

const Footer = () => {
  return (
    <footer className="w-full h-auto bg-[#15233C] pl-[5vw] pr-[5vw] font-inria">
      <div className=" ml-[8vw] mr-[4vw] px-4 flex flex-cols-1 md:flex-cols-3 gap-8">
        <div className="basis-[45%] flex flex-col mt-12 pr-5">
          <h2 className=" text-2xl font-bold mb-2 text-[#D9D9D9]">Contact</h2>
          <p className="font-bold text-xl text-[#909090] ml-20 mb-3">
            tipscrossborder.com
          </p>

          <p className="flex text-sm font-bold text-[#B6B6B6] leading-[127%] mb-2">
            <svg
              className="w-5 h-5 pt-1 mr-3"
              viewBox="0 0 11 11"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.46131 11C8.10203 9 10.2146 6.98535 10.2146 4.5C10.2146 2.01465 8.08648 0 5.46131 0C2.83614 0 0.708008 2.01465 0.708008 4.5C0.708008 6.98535 2.82059 9 5.46131 11ZM5.46131 6C6.33637 6 7.04574 5.32861 7.04574 4.5C7.04574 3.67139 6.33637 3 5.46131 3C4.58625 3 3.87687 3.67139 3.87687 4.5C3.87687 5.32861 4.58625 6 5.46131 6Z"
                fill="#D9D9D9"
              />
            </svg>
            The Kriss Express 2 Ratchada Room no. 28/65 Floor 6 Soi
            Ratchadapisek 19, Ratchadaphisek Subdistrict, Din Daeng District,
            Bangkok 10400
          </p>

          <p className="flex text-[#B6B6B6] text-sm mb-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
              className="w-5 h-5 pt-1 mr-1"
              fill="#B6B6B6"
            >
              <path d="M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z" />
            </svg>
            +66
          </p>

          <a className="flex text-[#B6B6B6] text-sm">
            <img
              className="w-5 h-5  mr-1"
              src="https://img.icons8.com/plasticine/100/new-post--v1.png"
              alt="new-post--v1"
            />
            contact.tipscrossborder@gmail.com
          </a>
        </div>

        <div className="basis-[25%] flex flex-col mt-10 font-bold">
          <h2 className="text-2xl  mb-2 text-[#D9D9D9]">Quick links</h2>
          <NavLink
            className="flex hover:underline text-[#909090] items-center text-xs mt-2"
            to="/#home"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-3 h-3 mr-2"
              viewBox="0 0 24 24"
              fill="#909090"
            >
              <path d="M7.293 4.707 14.586 12l-7.293 7.293 1.414 1.414L17.414 12 8.707 3.293 7.293 4.707z" />
            </svg>
            Home
          </NavLink>
          <NavLink
            className="flex hover:underline text-[#909090] items-center text-xs mt-2"
            to="/#product"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-3 h-3 mr-2 "
              viewBox="0 0 24 24"
              fill="#909090"
            >
              <path d="M7.293 4.707 14.586 12l-7.293 7.293 1.414 1.414L17.414 12 8.707 3.293 7.293 4.707z" />
            </svg>
            Our Product
          </NavLink>
          <NavLink
            className="flex hover:underline text-[#909090] items-center text-xs mt-2"
            to="/#strength"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-3 h-3 mr-2"
              viewBox="0 0 24 24"
              fill="#909090"
            >
              <path d="M7.293 4.707 14.586 12l-7.293 7.293 1.414 1.414L17.414 12 8.707 3.293 7.293 4.707z" />
            </svg>
            Strength
          </NavLink>
          <NavLink
            className="flex hover:underline text-[#909090] items-center text-xs mt-2"
            to="/#review"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-3 h-3 mr-2"
              viewBox="0 0 24 24"
              fill="#909090"
            >
              <path d="M7.293 4.707 14.586 12l-7.293 7.293 1.414 1.414L17.414 12 8.707 3.293 7.293 4.707z" />
            </svg>
            Reviews
          </NavLink>
          <NavLink
            className="flex hover:underline text-[#909090] items-center text-xs mt-2"
            to="/"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-3 h-3 mr-2"
              viewBox="0 0 24 24"
              fill="#909090"
            >
              <path d="M7.293 4.707 14.586 12l-7.293 7.293 1.414 1.414L17.414 12 8.707 3.293 7.293 4.707z" />
            </svg>
            FAQs
          </NavLink>
          <NavLink
            className="flex hover:underline text-[#909090] items-center text-xs mt-2"
            to="/"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-3 h-3 mr-2"
              viewBox="0 0 24 24"
              fill="#909090"
            >
              <path d="M7.293 4.707 14.586 12l-7.293 7.293 1.414 1.414L17.414 12 8.707 3.293 7.293 4.707z" />
            </svg>
            Service
          </NavLink>
        </div>
        <div className="basis-[30%] flex justify-center items-center">
          <img src="/logo.png" alt="" className="w-full h-auto" />
        </div>
      </div>

      <div className="mt-8 border-t font-bold border-white pt-4 text-xs flex flex-col md:flex-row justify-between items-center px-[9vw] pb-3">
        <p className="text-[#909090]">
          © 2023{" "}
          <a className="text-[#00EAFF]">Numsab Insurance Broker Co.,Ltd</a>, All
          Rights Reserved.
        </p>
        <p className="text-[#909090]">
          Develop By <a className="text-[#00EAFF]">Markmins</a> | Designed by{" "}
          <a className="text-[#00EAFF] ">Francis</a>
        </p>
      </div>

      <button
        className="fixed bottom-4 right-4 bg-[#2257A8] hover:bg-blue-700 text-white rounded-xl p-3 shadow-lg z-[9000]"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      >
        <FaArrowUp />
      </button>
    </footer>
  );
};

export default Footer;
